import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaMagic, FaTrashAlt } from 'react-icons/fa';

const Step3MonthlySchedule = () => {
  const [viewMode, setViewMode] = useState('Month');

  // Exact 31-day tracking numbers array
  const totalDaysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);

  // Exact mock structure mappings from dashboard layout image
  const daysOfWeekMap = ['Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu'];

  const staffRoster = [
    { name: 'Ahmed Raza', role: 'Head Chef', initials: 'AR', defaultShift: 'AM', pattern: ['AM', 'AM', 'H', 'AM', 'PM', 'AM', 'AM', 'PM', 'H', 'AM', 'OFF', 'AM', 'PM', 'PM', 'AM', 'AM', 'H', 'AM', 'AM', 'AM', 'PM', 'AM', 'AM', 'PM', 'AM', 'PM', 'OFF', 'AM', 'AM', 'PM', 'AM'] },
    { name: 'Sara Khan', role: 'Server', initials: 'SK', defaultShift: 'PM', pattern: ['PM', 'AM', 'OFF', 'OFF', 'PM', 'OFF', 'AM', 'PM', 'OFF', 'AM', 'OFF', 'OFF', 'PM', 'PM', 'PM', 'AM', 'OFF', 'OFF', 'PM', 'AM', 'AM', 'PM', 'AM', 'OFF', 'OFF', 'PM', 'PM', 'AM', 'PM', 'AM', 'PM'] },
    { name: 'John Smith', role: 'Kitchen Assistant', initials: 'JS', defaultShift: 'AM', pattern: ['AM', 'AM', 'OFF', 'AM', 'AM', 'AM', 'AM', 'AM', 'AM', 'OFF', 'H', 'AM', 'AM', 'AM', 'AM', 'OFF', 'AM', 'AM', 'PM', 'AM', 'OFF', 'AM', 'AM', 'OFF', 'PM', 'H', 'AM', 'AM', 'AM', 'OFF', 'OFF'] },
    { name: 'Emily White', role: 'Server', initials: 'EW', defaultShift: 'PM', pattern: ['PM', 'PM', 'OFF', 'PM', 'PM', 'PM', 'PM', 'OFF', 'PM', 'PM', 'H', 'PM', 'PM', 'PM', 'PM', 'H', 'PM', 'PM', 'OFF', 'PM', 'PM', 'PM', 'PN', 'H', 'OFF', 'PM', 'OFF', 'PM', 'AM', 'PM', 'OFF'] },
    { name: 'Usman Ali', role: 'Manager', initials: 'UA', defaultShift: 'OFF', pattern: ['OFF', 'AM', 'OFF', 'PM', 'OFF', 'OFF', 'PM', 'OFF', 'AM', 'AM', 'AM', 'OFF', 'OFF', 'PM', 'OFF', 'AM', 'AM', 'PM', 'OFF', 'PM', 'OFF', 'AM', 'AM', 'PM', 'OFF', 'AM', 'AM', 'PM', 'AM', 'PM', 'PM'] },
    { name: 'Zainab Butt', role: 'Cleaner', initials: 'ZB', defaultShift: 'PM', pattern: ['PM', 'OFF', 'H', 'PM', 'OFF', 'H', 'PM', 'OFF', 'H', 'AM', 'PM', 'OFF', 'H', 'AM', 'PM', 'OFF', 'H', 'AM', 'PM', 'OFF', 'H', 'PM', 'OFF', 'H', 'AM', 'PM', 'OFF', 'H', 'PM', 'OFF', 'AM'] }
  ];

  const getShiftBadgeStyles = (type) => {
    switch (type) {
      case 'AM': return 'bg-emerald-100 text-emerald-800 border-emerald-200 font-bold';
      case 'PM': return 'bg-blue-100 text-blue-800 border-blue-200 font-bold';
      case 'OFF': return 'bg-slate-100 text-slate-400 border-slate-200 font-medium';
      case 'H': return 'bg-red-50 text-red-600 border-red-200 font-bold';
      default: return 'bg-amber-100 text-amber-800 border-amber-200';
    }
  };

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
      {/* Dynamic Controls Header Banner */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-5">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold text-sm">3</div>
          <div>
            <h2 className="text-md font-bold text-gray-900">Monthly Schedule</h2>
            <p className="text-[11px] text-gray-400">Assign shifts and checks for each day of the month.</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button className="flex items-center gap-1 px-2.5 py-1.5 border border-blue-200 text-blue-600 bg-blue-50/50 rounded text-xs font-semibold hover:bg-blue-50">
            <FaMagic size={10} /> Auto Fill Month
          </button>
          <button className="flex items-center gap-1 px-2.5 py-1.5 border border-red-200 text-red-600 bg-red-50/50 rounded text-xs font-semibold hover:bg-red-50">
            <FaTrashAlt size={10} /> Clear All
          </button>
          <div className="flex border border-gray-300 rounded overflow-hidden ml-2">
            {['Month', 'Week', 'List'].map((mode) => (
              <button
                key={mode}
                onClick={() => setViewMode(mode)}
                className={`px-3 py-1 text-xs font-semibold ${viewMode === mode ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
              >
                {mode}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Navigation Sub-toolbar */}
      <div className="flex items-center gap-2 mb-4 text-xs font-semibold text-gray-700 bg-slate-50 p-2 rounded border border-gray-200">
        <span className="text-[10px] text-gray-400 uppercase tracking-wide mr-2">View by Staff Member</span>
        <button className="p-1 border border-gray-300 rounded bg-white hover:bg-gray-50"><FaChevronLeft size={9} /></button>
        <span className="px-2">May 2026</span>
        <button className="p-1 border border-gray-300 rounded bg-white hover:bg-gray-50"><FaChevronRight size={9} /></button>
      </div>

      {/* Complete Horizontal Matrix Scroller Grid */}
      <div className="overflow-x-auto border border-gray-200 rounded-md">
        <table className="min-w-full border-collapse text-center text-[11px]">
          <thead className="bg-slate-100 font-bold text-gray-500 border-b border-gray-200">
            <tr>
              <th className="p-2.5 text-left bg-slate-100 font-bold sticky left-0 z-20 shadow-[2px_0_5px_rgba(0,0,0,0.02)] min-w-[140px] max-w-[140px]">Staff Member</th>
              <th className="p-2.5 bg-slate-100 border-r border-gray-200 min-w-[100px]">Role</th>
              {totalDaysInMonth.map((day) => (
                <th key={day} className="p-1.5 border-r border-gray-200 min-w-[36px] font-bold text-gray-700">
                  <div>{day}</div>
                  <div className="text-[9px] text-gray-400 font-semibold">{daysOfWeekMap[(day - 1) % 7]}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 font-medium">
            {staffRoster.map((staff, sIdx) => (
              <tr key={sIdx} className="hover:bg-slate-50 transition">
                <td className="p-2.5 text-left font-bold text-gray-900 bg-white sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.02)]">
                  <div className="flex items-center gap-1.5">
                    <div className="w-5 h-5 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center text-[9px] font-black">{staff.initials}</div>
                    <span className="truncate max-w-[100px]">{staff.name}</span>
                  </div>
                </td>
                <td className="p-2.5 border-r border-gray-200 text-left text-gray-400 text-[10px] truncate max-w-[100px]">{staff.role}</td>
                {totalDaysInMonth.map((day) => {
                  const shiftType = staff.pattern[day - 1] || 'OFF';
                  return (
                    <td key={day} className="p-1 border-r border-gray-200 align-middle">
                      <div className={`py-1 text-center rounded border text-[10px] ${getShiftBadgeStyles(shiftType)}`}>
                        {shiftType}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
            
            {/* Daily Operational Head Count Coverage Summary Indicator Metric */}
            <tr className="bg-slate-50 text-[10px] font-bold text-gray-700">
              <td className="p-2 text-left bg-slate-50 sticky left-0 z-10 shadow-[2px_0_5px_rgba(0,0,0,0.02)] uppercase tracking-wider text-gray-400">Daily Coverage</td>
              <td className="border-r border-gray-200"></td>
              {totalDaysInMonth.map((day) => {
                const count = day % 6 === 0 ? '4' : '5';
                return (
                  <td key={day} className={`p-1 border-r border-gray-200 font-black ${count === '4' ? 'text-red-500' : 'text-emerald-600'}`}>
                    {count}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Visual Identification Map Color Guide Key */}
      <div className="flex flex-wrap items-center gap-5 mt-4 pt-3 border-t border-gray-100 text-[11px] text-gray-500 font-medium">
        <div className="flex items-center gap-1.5"><span className="w-6 py-0.5 rounded text-center text-[9px] bg-emerald-100 text-emerald-800 border border-emerald-200 font-bold">AM</span> Morning Shift (e.g. 06:00 - 14:00)</div>
        <div className="flex items-center gap-1.5"><span className="w-6 py-0.5 rounded text-center text-[9px] bg-blue-100 text-blue-800 border border-blue-200 font-bold">PM</span> Afternoon Shift (e.g. 14:00 - 22:00)</div>
        <div className="flex items-center gap-1.5"><span className="w-6 py-0.5 rounded text-center text-[9px] bg-amber-100 text-amber-800 border border-amber-200 font-bold">OFF</span> Custom Shift (time defined)</div>
        <div className="flex items-center gap-1.5"><span className="w-6 py-0.5 rounded text-center text-[9px] bg-slate-100 text-slate-400 border border-slate-200 font-medium">OFF</span> Day Off</div>
        <div className="flex items-center gap-1.5"><span className="w-6 py-0.5 rounded text-center text-[9px] bg-red-50 text-red-600 border border-red-200 font-bold">H</span> Holiday / Leave</div>
      </div>
    </div>
  );
};

export default Step3MonthlySchedule;
